import PipelineTrackerCore from "../components/PipelineTrackerCore";
import PageScopeBanner from "../components/PageScopeBanner";
import PageHero from "../components/PageHero";
import { GitPullRequestArrow } from "lucide-react";

export default function PipelineTracker() {
  return (
    <div className="min-h-screen" style={{ background: "#060e18" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "24px 24px 0" }}>
        <PageHero icon={GitPullRequestArrow} title="Pre-Open Pipeline" testId="pipeline-hero"
          subtitle="Pre-open compliance, matter by matter, until the CCL is signed"
          tile="linear-gradient(135deg, #3b82f6, #6366f1 55%, #8b5cf6)" />
      </div>

      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px 80px" }}>
        <PageScopeBanner
          text="Pre-open compliance only — a matter graduates here automatically once the CCL is signed. Looking for matters that are already open?"
          linkTo="/matters"
          linkLabel="Open Matters"
          testId="pipeline-scope-banner"
        />
        <PipelineTrackerCore showMoneyBar />
      </div>
    </div>
  );
}
